// ─── 1. src/services/target.service.js ───────────────────────────────────────
import api from './api';

const targetService = {

  // Get my target for a month/year
  getMyTarget: async (month, year) => {
    try {
      const params = {};
      if (month) params.month = month;
      if (year)  params.year  = year;
      const res = await api.get('/targets/my', { params });
      return res.data;
    } catch (error) {
      console.error('Error fetching my target:', error);
      throw error;
    }
  },

  // Get team targets
  getTeamTargets: async (month, year) => {
    try {
      const params = {};
      if (month) params.month = month;
      if (year)  params.year  = year;
      const res = await api.get('/targets/team', { params });
      return res.data;
    } catch (error) {
      console.error('Error fetching team targets:', error);
      throw error;
    }
  },

  // Get users I can assign targets to
  getAssignableUsers: async () => {
    try {
      const res = await api.get('/targets/assignable');
      return res.data;
    } catch (error) {
      console.error('Error fetching assignable users:', error);
      throw error;
    }
  },

  // Set target for a user
  setTarget: async (data) => {
    try {
      const res = await api.post('/targets', data);
      return res.data;
    } catch (error) {
      console.error('Error setting target:', error);
      throw error;
    }
  },
};

export default targetService;